import React, { Fragment } from "react";
import { Field } from "redux-form";

const CustomInput = field => {
  const components = (
    <Fragment>
      {field.label && (
        <label htmlFor={`${field.input.name}_${field.radioValue}`} className="radio-field-label">
          {field.label}
        </label>
      )}
      <input
        {...field.input}
        id={`${field.input.name}_${field.radioValue}`}
        type="radio"
        value={field.radioValue}
        style={field.style}
        disabled={field.isReadOnly}
        checked={field.radioValue === field.input.value}
      />
      {!field.noErrorMsg && field.meta.touched && field.meta.error && (
        <span style={{ color: "red" }}>{field.meta.error}</span>
      )}
    </Fragment>
  );
  return field.noDivWrapper ? components : <div>{components}</div>;
};

const RadioField = props => <Field {...props} component={CustomInput} />;

export default RadioField;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/FormField/RadioField.js